import { ArrowBack, Category, Search as SearchIcon, Description, Event } from "@material-ui/icons";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styled, { keyframes, StyleSheetManager } from "styled-components";

import NewWindow from "react-new-window";

import "react-tabs/style/react-tabs.css";
import fetchClient from "../../api/fetchClient";
import Loader from '../../components/Loader';

import LogEvents from "../../components/LogEvents";
import SearchLogs from "../../components/SearchLogs";

import TransactionsTable from "../../components/logs/TransactionsTable";
import message from "../../helper/message";

const TYPE_OPTIONS = [
    { value: "purchase", label: "Purchase" },
    { value: "downpayment", label: "Downpayment" },
    { value: "journalEntry", label: "Journal Entry" },
    { value: "returnInvoice", label: "Return Invoice" },
];

function LogsViceri() {
    const history = useHistory();
    console.log('rendering lgos')

    const [logs, setlogs] = useState([])
    const [pending, setPending] = useState(false);
    const [pendings, setPendings] = useState([]);
    const [next, setNext] = useState(1);
    const [pendingView, setPendingView] = useState(null);
    const [empresa, setEmpresa] = useState(null);
    const [groupsLogs, setGroupsLogs] = useState([]);
    const [groupLog, setGroupLog] = useState(null);
    const [isOpened, setIsOpened] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isRemoving, setIsRemoving] = useState(false);
    const [logToRemove, setLogToRemove] = useState(null);
    const [type, setType] = useState(null);
    const [nextPage, setNextPage] = useState({
        has: false,
        link: null
    });
    const [windowFeatures, setWindowFeatures] = useState("left=0,top=0,width=1200,height=700,resizable=yes,scrollbars=yes");
    const [logWindow, setLogWindow] = useState(null);

    useEffect(() => {
        if (type) {
            getGroupLogs(type)
        }
        //eslint-disable-next-line
    }, [type]);

    useEffect(() => {
        if (typeof window === "undefined") return;
        const availWidth = window.screen?.availWidth || window.innerWidth || 1600;
        const availHeight = window.screen?.availHeight || window.innerHeight || 900;
        setWindowFeatures(`left=0,top=0,width=${availWidth},height=${availHeight},resizable=yes,scrollbars=yes`);
    }, []);

    const getGroupLogs = async (type, token = null) => {
        try {
            if (type === null) return
            setIsLoading(true);
            const { data } = await fetchClient.get(`viceri/getAllLogs?type=${type}${token ? `&nextToken=${token}` : ''}`);
            setGroupsLogs(old => token ? [...old, ...data.logStreams] : data.logStreams);
            if (data.nextToken) setNextPage({ has: true, link: data.nextToken });
            else setNextPage({ has: false, link: null });
        } catch (err) {
            console.log(err)
            message.error(err.response.data.message)
        }
        setIsLoading(false);
    }

    const handleSearch = async (search) => {
        setIsLoading(true)
        const { data } = await fetchClient.post("/viceri/queryLogs", {
            queryString: search,
            type,
        })
        setGroupsLogs(data)
        setIsLoading(false)
    }

    const selectedTypeLabel = TYPE_OPTIONS.find(option => option.value === type)?.label;

    const closeLogWindow = () => {
        setIsOpened(false);
        setPendingView(null);
        setLogWindow(null);
    };

    return (
        <Container>
            {
                (isOpened || pendingView) &&
                <NewWindow
                    title="Logs"
                    features={windowFeatures}
                    onOpen={(win) => setLogWindow(win)}
                    onUnload={closeLogWindow}
                    onClose={closeLogWindow}
                >
                    {logWindow && (
                        <StyleSheetManager target={logWindow.document.head}>
                            <LogEvents
                                groupLog={groupLog}
                                viceri={true}
                                type={type}
                            />
                        </StyleSheetManager>
                    )}
                </NewWindow>
            }
            <Page>
                <PageContent>
                    <ModernHeader>
                        <HeaderLeft>
                            <BackButton onClick={() => history.goBack()}>
                                <ArrowBack />
                            </BackButton>
                            <HeaderContent>
                                <PageTitle>
                                    <Description style={{ marginRight: '12px', fontSize: '32px' }} />
                                    Logs Viceri
                                </PageTitle>
                                <PageSubtitle>Visualize e busque logs de eventos do sistema</PageSubtitle>
                            </HeaderContent>
                        </HeaderLeft>
                        <SelectedChips>
                            {selectedTypeLabel && (
                                <SelectedBadge>
                                    <Category style={{ fontSize: '16px', marginRight: '4px' }} />
                                    {selectedTypeLabel}
                                </SelectedBadge>
                            )}
                        </SelectedChips>
                    </ModernHeader>

                    <FiltersCard>
                        <SectionHeader>
                            <SectionIcon color="#667eea">
                                <SearchIcon />
                            </SectionIcon>
                            <SectionTitle>Filtros de Busca</SectionTitle>
                        </SectionHeader>
                        <FormGrid>
                            <StyledFieldContainer>
                                <FieldLabel>
                                    <Category style={{ fontSize: '18px', marginRight: '8px', color: '#667eea' }} />
                                    Tipo de Log
                                </FieldLabel>
                                <TypeSelect value={type || ""} onChange={event => setType(event.target.value)}>
                                    <option disabled={true} value="">Selecionar tipo</option>
                                    {TYPE_OPTIONS.map(option => (
                                        <option key={option.value} value={option.value}>{option.label}</option>
                                    ))}
                                </TypeSelect>
                            </StyledFieldContainer>
                            <StyledFieldContainer>
                                <FieldLabel>
                                    <SearchIcon style={{ fontSize: '18px', marginRight: '8px', color: '#667eea' }} />
                                    Busca Avançada
                                </FieldLabel>
                                <SearchWrapper>
                                    <SearchLogs
                                        onSearch={handleSearch}
                                    />
                                </SearchWrapper>
                            </StyledFieldContainer>
                        </FormGrid>
                        <FilterHelper>
                            <Event style={{ fontSize: '16px', marginRight: '8px' }} />
                            Defina um tipo antes de consultar. Utilize a busca para localizar termos específicos dentro dos eventos.
                        </FilterHelper>
                    </FiltersCard>

                    {
                        isLoading ? (
                            <LoaderWrapper>
                                <Loader />
                            </LoaderWrapper>
                        ) : !type ? (
                            <ResultsCard>
                                <EmptyState>
                                    <Description style={{ fontSize: '48px', color: '#cbd5e1', marginBottom: '16px' }} />
                                    <EmptyTitle>Nenhum tipo selecionado</EmptyTitle>
                                    <EmptyText>Escolha um tipo de log para visualizar os eventos disponíveis.</EmptyText>
                                </EmptyState>
                            </ResultsCard>
                        ) : (
                            <ResultsCard>
                                                {
                                                    pending ?
                                                        <TransactionsTable
                                                            type={type}
                                                            transactions={pendings}
                                                            onConsultLog={(item) => {
                                                                setIsOpened(true);
                                                                setGroupLog(item);
                                                            }}
                                                            onConsult={setPendingView}
                                                            onRemove={(id) => {
                                                                setLogToRemove(id)
                                                                setIsRemoving(true)
                                                            }}
                                                        />
                                                        :
                                                        <>
                                                            <SectionInfo>
                                                                <SectionInfoTitle>Streams recentes</SectionInfoTitle>
                                                                <SectionSubtitle>
                                                                    {groupsLogs.length > 0 ?
                                                                        `Mostrando ${groupsLogs.length} ${groupsLogs.length === 1 ? 'stream' : 'streams'}` :
                                                                        "Nenhum stream encontrado"}
                                                                </SectionSubtitle>
                                                            </SectionInfo>
                                                            {
                                                                groupsLogs.length === 0 ? (
                                                                    <EmptyState>
                                                                        <Description style={{ fontSize: '48px', color: '#cbd5e1', marginBottom: '16px' }} />
                                                                        <EmptyTitle>Nenhum registro encontrado</EmptyTitle>
                                                                        <EmptyText>Nenhum registro encontrado para este tipo. Ajuste os filtros ou tente novamente mais tarde.</EmptyText>
                                                                    </EmptyState>
                                                                ) :
                                                                    <TableWrapper>
                                                                        <StreamsTable>
                                                                            <thead>
                                                                                <tr>
                                                                                    <TableHead>ID do stream</TableHead>
                                                                                    <TableHead>Último evento</TableHead>
                                                                                    <TableHead align="right">Ações</TableHead>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {groupsLogs.map(({ logStreamName, lastEventTimestamp }) => (
                                                                                    <TableRow key={logStreamName}>
                                                                                        <StreamName title={logStreamName}>
                                                                                            {logStreamName}
                                                                                        </StreamName>
                                                                                        <EventTime>
                                                                                            {moment(lastEventTimestamp).format('DD/MM/YYYY HH:mm')}
                                                                                        </EventTime>
                                                                                        <TableActions>
                                                                                            <ConsultResult
                                                                                                onClick={() => {
                                                                                                    setGroupLog(logStreamName);
                                                                                                    setIsOpened(true);
                                                                                                }}
                                                                                            >
                                                                                                Consultar
                                                                                            </ConsultResult>
                                                                                        </TableActions>
                                                                                    </TableRow>
                                                                                ))}
                                                                            </tbody>
                                                                        </StreamsTable>
                                                                    </TableWrapper>
                                                            }
                                                            {
                                                                nextPage.has && (
                                                                    <MoreWrapper>
                                                                        <MoreButton
                                                                            onClick={() => getGroupLogs(type, nextPage.link)}
                                                                        >
                                                                            Carregar mais
                                                                        </MoreButton>
                                                                    </MoreWrapper>
                                                                )
                                                            }
                                                        </>
                                                }
                                            </ResultsCard>
                                        )
                                    }
                </PageContent>
            </Page>
        </Container>
    )
}

export default LogsViceri;

// Animações
const fadeIn = keyframes`
	from {
		opacity: 0;
		transform: translateY(20px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
`;

const MoreButton = styled.button`
	min-width: 180px;
	height: 44px;
	border: none;
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	color: #fff;
	font-size: 15px;
	font-weight: 600;
	border-radius: 12px;
	padding: 0 32px;
	cursor: pointer;
	font-family: 'Mulish', sans-serif;
	transition: all 0.3s ease;
	box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);

	&:hover {
		transform: translateY(-2px);
		box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
	}

	&:active {
		transform: translateY(0);
	}

	&:disabled {
		background: #c7d3e3;
		cursor: not-allowed;
		transform: none;
		box-shadow: none;
	}
`;

const ConsultResult = styled.button`
	background: ${props => props.remove ? 'linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'};
	color: #fff;
	border: none;
	border-radius: 10px;
	padding: 8px 18px;
	font-size: 13px;
	font-weight: 600;
	cursor: pointer;
	font-family: 'Mulish', sans-serif;
	transition: all 0.3s ease;
	box-shadow: 0 2px 8px ${props => props.remove ? 'rgba(231, 76, 60, 0.3)' : 'rgba(102, 126, 234, 0.3)'};

	&:hover {
		transform: translateY(-2px);
		box-shadow: 0 4px 12px ${props => props.remove ? 'rgba(231, 76, 60, 0.4)' : 'rgba(102, 126, 234, 0.4)'};
	}

	&:active {
		transform: translateY(0);
	}
`;

const TypeSelect = styled.select`
	width: 100%;
	height: 42px;
	border-radius: 10px;
	border: 1px solid #d5dbe0;
	padding: 0 12px;
	font-size: 15px;
	color: #273240;
	background: #fff;
	font-family: 'Mulish', sans-serif;
	box-shadow: 0 1px 2px rgba(32, 33, 36, 0.05);
	transition: border-color 0.2s ease, box-shadow 0.2s ease;
	&:hover,
	&:focus {
		border-color: #667eea;
		box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
		outline: none;
	}
`;

const LoaderWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 320px;
	background: white;
	border-radius: 16px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
	width: 100%;
	box-sizing: border-box;
`;

const ResultsCard = styled.div`
	width: 100%;
	background: white;
	border: 1px solid #e8e8e8;
	border-radius: 16px;
	padding: 28px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
	animation: ${fadeIn} 0.5s ease;
	transition: all 0.3s ease;
	box-sizing: border-box;

	&:hover {
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
		border-color: #d0d0d0;
	}
`;

const Container = styled.div`
	width: 100%;
	min-height: calc(100vh - 65px);
	padding: 24px;
	background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
	font-family: 'Mulish', sans-serif;
	box-sizing: border-box;
	overflow-x: hidden;

	@media (max-width: 768px) {
		padding: 16px;
	}
`;

const Page = styled.div`
	max-width: 1400px;
	margin: 0 auto;
	width: 100%;
	box-sizing: border-box;
`;

const PageContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	width: 100%;
	box-sizing: border-box;
`;

const ModernHeader = styled.div`
	padding: 24px 0;
	margin-bottom: 8px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 20px;
	animation: ${fadeIn} 0.6s ease;
	width: 100%;
	box-sizing: border-box;

	@media (max-width: 768px) {
		flex-direction: column;
		align-items: flex-start;
		padding: 16px 0;
	}
`;

const HeaderLeft = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;
	flex: 1;
`;

const HeaderContent = styled.div`
	flex: 1;
`;

const PageTitle = styled.h1`
	font-size: 28px;
	font-weight: 700;
	color: #2c3e50;
	margin: 0 0 6px 0;
	display: flex;
	align-items: center;
	font-family: 'Mulish', sans-serif;

	@media (max-width: 768px) {
		font-size: 22px;
	}
`;

const PageSubtitle = styled.p`
	font-size: 14px;
	color: #7f8c8d;
	margin: 0;
	font-family: 'Mulish', sans-serif;
`;

const BackButton = styled.button`
	background: rgba(102, 126, 234, 0.1);
	border: none;
	border-radius: 12px;
	width: 42px;
	height: 42px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	color: #667eea;
	transition: all 0.3s ease;
	flex-shrink: 0;

	&:hover {
		background: rgba(102, 126, 234, 0.2);
		transform: translateX(-4px);
	}

	&:active {
		transform: translateX(0);
	}
`;

const SelectedChips = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 10px;

	@media (max-width: 768px) {
		width: 100%;
	}
`;

const SelectedBadge = styled.div`
	display: inline-flex;
	align-items: center;
	padding: 8px 16px;
	background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
	color: #667eea;
	border-radius: 20px;
	font-size: 13px;
	font-weight: 600;
	font-family: 'Mulish', sans-serif;
	border: 1px solid rgba(102, 126, 234, 0.2);
	transition: all 0.3s ease;

	&:hover {
		border-color: #667eea;
		background: linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%);
	}
`;

const FiltersCard = styled.div`
	background: white;
	border: 1px solid #e8e8e8;
	border-radius: 16px;
	padding: 24px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
	animation: ${fadeIn} 0.5s ease 0.1s both;
	transition: all 0.3s ease;
	width: 100%;
	box-sizing: border-box;

	&:hover {
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
		border-color: #d0d0d0;
	}
`;

const SectionHeader = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: 20px;
	padding-bottom: 16px;
	border-bottom: 2px solid #f0f0f0;
	width: 100%;
	box-sizing: border-box;
`;

const SectionIcon = styled.div`
	width: 40px;
	height: 40px;
	border-radius: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: ${props => props.color ? `${props.color}15` : 'rgba(102, 126, 234, 0.1)'};
	color: ${props => props.color || '#667eea'};
	margin-right: 12px;
	transition: all 0.3s ease;

	svg {
		font-size: 22px;
	}

	${FiltersCard}:hover & {
		transform: scale(1.1);
	}
`;

const SectionTitle = styled.h3`
	font-size: 18px;
	font-weight: 700;
	color: #2c3e50;
	margin: 0;
	font-family: 'Mulish', sans-serif;
`;

const FormGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 20px;

	@media (max-width: 768px) {
		grid-template-columns: 1fr;
	}
`;

const StyledFieldContainer = styled.div`
	display: flex;
	flex-direction: column;
	grid-column: ${props => props.fullWidth ? '1 / -1' : 'auto'};
`;

const FieldLabel = styled.label`
	font-size: 14px;
	font-weight: 600;
	color: #2c3e50;
	margin-bottom: 8px;
	display: flex;
	align-items: center;
	font-family: 'Mulish', sans-serif;
`;

const SearchWrapper = styled.div`
	width: 100%;
	> div {
		width: 100%;
	}
`;

const FilterHelper = styled.div`
	margin-top: 20px;
	padding: 14px 18px;
	background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);
	border-left: 4px solid #667eea;
	border-radius: 8px;
	font-size: 13px;
	color: #5c6b7a;
	font-family: 'Mulish', sans-serif;
	display: flex;
	align-items: center;
	line-height: 1.5;
`;

const SectionInfo = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	margin-bottom: 16px;
`;

const SectionSubtitle = styled.span`
	font-size: 14px;
	color: #64748b;
	font-family: 'Mulish', sans-serif;
`;

const SectionInfoTitle = styled.h3`
	margin: 0;
	font-size: 20px;
	color: #1f2933;
	font-family: 'Mulish', sans-serif;
`;

const TableWrapper = styled.div`
	width: 100%;
	overflow-x: auto;
	overflow-y: visible;
	margin-top: 12px;
	box-sizing: border-box;
`;

const StreamsTable = styled.table`
	width: 100%;
	border-collapse: collapse;
	min-width: 520px;
`;

const TableHead = styled.th`
	text-align: ${props => props.align || 'left'};
	font-size: 13px;
	letter-spacing: 0.05em;
	text-transform: uppercase;
	color: #6b7280;
	padding: 12px 16px;
	border-bottom: 1px solid #e5e7eb;
	font-family: 'Mulish', sans-serif;
`;

const TableRow = styled.tr`
	border-bottom: 1px solid #eef2f7;
	&:hover {
		background: #f9fbff;
	}
`;

const StreamName = styled.td`
	font-weight: 600;
	color: #0f172a;
	padding: 12px 16px;
	max-width: 360px;
	overflow: hidden;
	text-overflow: ellipsis;
	font-family: 'Mulish', sans-serif;
`;

const EventTime = styled.td`
	padding: 12px 16px;
	color: #4c5968;
	font-size: 14px;
	font-family: 'Mulish', sans-serif;
`;

const TableActions = styled.td`
	padding: 12px 16px;
	text-align: right;
	position: relative;
	overflow: visible;
`;

const MoreWrapper = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 16px;
`;

const EmptyState = styled.div`
	width: 100%;
	box-sizing: border-box;
	padding: 64px 48px;
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	font-family: 'Mulish', sans-serif;
`;

const EmptyTitle = styled.h3`
	font-size: 20px;
	font-weight: 700;
	color: #2c3e50;
	margin: 0 0 8px 0;
	font-family: 'Mulish', sans-serif;
`;

const EmptyText = styled.p`
	font-size: 14px;
	color: #7f8c8d;
	margin: 0;
	max-width: 400px;
	line-height: 1.5;
	font-family: 'Mulish', sans-serif;
`;
